import { routes } from '@/app/routing/router'
import { SocialView } from './view'

const currentRoute = routes.social

const SocialRoute = {
  route: currentRoute,
  view: SocialView,
}

export { currentRoute, SocialRoute }
